import React from 'react'

import { Translate } from '@hozana/intl/Translate'
import { QA } from '@hozana/tests/constants'

import { Block } from 'elements/layout/Block'
import { Space } from 'elements/layout/Space'

import { CommunityPageSubTitle } from 'modules/community/components/CommunityPageSubTitle'
import { CommunityPrayer } from 'modules/community/components/CommunityPrayer'
import type { TCommunity } from 'modules/community/types'

export type TCommunityPrayerBlockProps = {
  community: TCommunity
}

export const CommunityPrayerBlock: TFC<TCommunityPrayerBlockProps> = ({ community }) => (
  <Block
    square
    noOverflow
    maxW={{ xs: 'initial', md: '712px', lg: 'initial' }}
    m={{ xs: '1em auto', lg: '1em 0' }}
    p="1em"
    data-testid={QA.COMMUNITY_PAGE.PRAYER_BLOCK}
  >
    <CommunityPageSubTitle>
      <Translate values={{ lifetime: community.lifetime }}>
        trans:community:community.description.prayer.intro
      </Translate>
    </CommunityPageSubTitle>
    <CommunityPrayer title={community.prayerName} content={community.prayerContent} />
    <Space />
  </Block>
)
